import { config } from 'ENV_CONFIG';

import { config as homeDesignInStoreConfig } from './home-design/in-store/config';
import { config as homeDesignAtHomeConfig } from './home-design/at-home/config';
import { config as nurseryConfig } from './nursery/config';
import { config as personalStylingConfig } from './personal-styling/config';
import { config as fittedKitchensConfig } from './fitted-kitchens/config';
import { config as fittedBathroomsConfig } from './fitted-bathrooms/config';
import { config as fittedBedroomsConfig } from './fitted-bedrooms/config';
import { config as lingerieConfig } from './lingerie/config';
import { config as pelotonConfig } from './peloton/config';
import { config as opticalServicesConfig } from './optical-services/config';
import { config as childrensShoeFittingServicesConfig } from './childrens-shoe-fitting/config';
import { config as beautySocietyConfig } from './beauty-society/config';
import { config as beautyConfig } from './beauty/config';
import { config as measureConfig } from './measure/config';
import { config as homeServicesConfig } from './home-services/config';
import { config as piercingConfig } from './piercing/config';
import { services } from './services.constant';

const serviceIdToConfigMap = {
  [services.PERSONAL_STYLING.name]: {
    ...personalStylingConfig,
  },
  [services.NURSERY.name]: {
    ...nurseryConfig,
  },
  [services.FITTED_KITCHENS.name]: {
    ...fittedKitchensConfig,
  },
  [services.FITTED_BATHROOMS.name]: {
    ...fittedBathroomsConfig,
  },
  [services.FITTED_BEDROOMS.name]: {
    ...fittedBedroomsConfig,
  },
  [services.LINGERIE.name]: {
    ...lingerieConfig,
  },
  [services.PELOTON.name]: {
    ...pelotonConfig,
  },
  [services.OPTICAL_SERVICES.name]: {
    ...opticalServicesConfig,
  },
  [services.CHILDREN_SHOE_FITTING.name]: {
    ...childrensShoeFittingServicesConfig,
  },
  [services.BEAUTY_SOCIETY.name]: {
    ...beautySocietyConfig,
  },
  [services.BEAUTY.name]: {
    ...beautyConfig,
  },
  [services.MEASURE.name]: {
    ...measureConfig,
  },
  [services.HOME_SERVICES.name]: {
    ...homeServicesConfig,
  },
  [services.PIERCING.name]: {
    ...piercingConfig,
  },
};

export const getServiceConfig = (serviceName, appointmentTypeId) => {
  if (serviceName === services.HOME_DESIGN.name) {
    return config.services[services.HOME_DESIGN.name].atHomeAppointmentTypeIds.includes(
      appointmentTypeId,
    )
      ? homeDesignAtHomeConfig
      : homeDesignInStoreConfig;
  }
  return serviceIdToConfigMap[serviceName];
};
